import styled from "styled-components";

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem 0.75rem;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;
